import React from 'react';
import { Chip } from '@mui/material';

const PLATFORM_COLORS = {
  Apollo: '#1976d2',
  Prism: '#2e7d32',
  PrismIntl: '#6a1b9a',
  RMX: '#ed6c02',
};

// Canonical display order. The vPlanningItem STRING_AGG produces tokens in an
// undefined order (DB compat level 100 forbids WITHIN GROUP), so sort here.
const PLATFORM_ORDER = ['Apollo', 'Prism', 'PrismIntl', 'RMX'];

export default function PlatformBadges({ platforms }) {
  if (!platforms) {
    return null;
  }

  const list = platforms
    .split(',')
    .map((p) => p.trim())
    .filter((p) => p.length > 0)
    .sort((a, b) => {
      const ia = PLATFORM_ORDER.indexOf(a);
      const ib = PLATFORM_ORDER.indexOf(b);
      return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
    });

  if (list.length === 0) {
    return null;
  }

  return (
    <>
      {list.map((platform) => (
        <Chip
          key={platform}
          label={platform}
          size='small'
          sx={{
            marginRight: '4px',
            marginBottom: '2px',
            backgroundColor: PLATFORM_COLORS[platform] || '#9e9e9e',
            color: '#fff',
          }}
        />
      ))}
    </>
  );
}
